import React from "react";
import { Button,styled } from "@material-ui/core";
const AnimatedButton = styled(Button)(
  ({ theme, btnWidth, btnHeight, primarycolor }) => ({
    color: primarycolor
      ? theme?.agentTheme?.primary?.main
      : theme?.agentTheme?.secondary?.foreground,
    backgroundColor: primarycolor
      ? 'transparent'
      : theme?.agentTheme?.secondary?.main,
    position: "relative",
    overflow: "hidden",
    width: btnWidth || "auto",
    height: btnHeight || "auto",
    padding: "0.8rem 3rem",
    borderRadius: "2rem",
    textTransform: "none",
    zIndex: 0,
    border: primarycolor
      ? `1px solid ${theme?.agentTheme?.primary?.main}`
      : "none",
    transition: "color 0.8s ease, background-color 0.8s ease",
    boxShadow: "none",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "0%",
      height: "100%",
      backgroundColor: theme?.agentTheme?.primary?.main,
      zIndex: -1,
      transition: "width 0.8s ease",
    },

    "&:hover": {
      color: theme?.agentTheme?.primary?.foreground,
      backgroundColor: primarycolor
        ? theme?.agentTheme?.card?.main
        : theme?.agentTheme?.secondary?.main,
      boxShadow: "none",
    },

    "&:hover::before": {
      width: "100%",
    },
  })
);

export default function AnimationButton({
  name,
  width,
  height,
  primarycolor = false,
  clickfunction = () => {},
}) {
  return (
    <AnimatedButton
      variant="contained"
      btnWidth={width}
      btnHeight={height}
      primarycolor={primarycolor}
      onClick={clickfunction}
    >
      {name || "Click Me"}
    </AnimatedButton>
  );
}


const SecondaryButton = styled(Button)(({ theme, btnWidth, btnHeight }) => ({
  color: theme?.agentTheme?.secondary?.foreground,
  backgroundColor: theme?.agentTheme?.secondary?.main,
  width: btnWidth || "auto",
  height: btnHeight || "auto",
  padding: "0.8rem 3rem",
  borderRadius: "2rem",
  textTransform: "none",
  position: "relative",
  overflow: "hidden",
  border: "none",
  boxShadow: "none",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  zIndex: 0,
  transition: "color 0.8s ease, background-color 0.8s ease",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "0%",
    height: "100%",
    backgroundColor: theme?.agentTheme?.primary?.light,
    zIndex: -1,
    transition: "width 0.8s ease",
  },

  "&:hover": {
    color: theme?.agentTheme?.primary?.foreground,
    backgroundColor: theme?.agentTheme?.primary?.light,
    boxShadow: "none",
  },

  "&:hover::before": {
    width: "100%",
  },
}));

export  function NewButtonLogin({ name, width, height }) {
  return (
    <SecondaryButton btnWidth={width} btnHeight={height}>
      {name || "Know More"}
    </SecondaryButton>
  );
}
